// Import jQuery and related libraries
import jQuery from 'jquery'
window.jQuery = jQuery
window.$ = jQuery

import 'selectize'
